import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import {
  Department,
  GeckoSiteObservation,
  ObservationType,
  Severity,
} from 'types'

import {
  DepartmentDropdown,
  ObservationTypeDropdown,
  SeverityDropdown,
} from './Dropdowns'

interface ObservationDetailsFormProps {
  formData: Partial<GeckoSiteObservation['data']>
  setFormData: React.Dispatch<
    React.SetStateAction<Partial<GeckoSiteObservation['data']>>
  >
  disabled: boolean
  labelStyle: React.CSSProperties
  inputBaseStyle: React.CSSProperties
  rowStyle: React.CSSProperties
  gridRowStyle: React.CSSProperties
  threeColumnGridStyle: React.CSSProperties
  StyledDatePickerWrapper: React.ElementType
}

export const ObservationDetailsForm: React.FC<ObservationDetailsFormProps> = ({
  formData,
  setFormData,
  disabled,
  labelStyle,
  inputBaseStyle,
  rowStyle,
  threeColumnGridStyle,
  StyledDatePickerWrapper,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={threeColumnGridStyle}>
        <label style={labelStyle}>Date Found</label>
        <StyledDatePickerWrapper>
          <DatePicker
            style={{ backgroundColor: '#2a2a2a', width: '100%' }}
            value={
              typeof formData.date_found === 'string' && formData.date_found
                ? dayjs(formData.date_found)
                : null
            }
            onChange={(date, dateString) => {
              const finalDateString =
                typeof dateString === 'string' ? dateString : undefined
              setFormData((prev) => ({
                ...prev,
                date_found: finalDateString,
              }))
            }}
            disabled={disabled}
            onMouseDown={(e) => e.stopPropagation()}
            placeholder='Date'
          />
        </StyledDatePickerWrapper>
        <label style={labelStyle}>Notif #</label>
        <input
          type='text'
          style={inputBaseStyle}
          value={formData.notification_number?.toString() || ''}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              notification_number: e.target.value,
            }))
          }
          placeholder='Notification number'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
        <label style={labelStyle}>WO #</label>
        <input
          type='text'
          style={inputBaseStyle}
          value={formData.wo_number?.toString() || ''}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              wo_number: e.target.value,
            }))
          }
          placeholder='Work order number'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>

      <div style={threeColumnGridStyle}>
        <label style={labelStyle}>Severity</label>
        <SeverityDropdown
          defaultValue={formData.severity}
          onValueChange={(val) => {
            setFormData((prev) => ({
              ...prev,
              severity: val ? (val as Severity) : undefined,
            }))
          }}
          disabled={disabled}
        />
        <label style={labelStyle}>Type</label>
        <ObservationTypeDropdown
          defaultValue={formData.type}
          onValueChange={(val) => {
            setFormData((prev) => ({
              ...prev,
              type: val ? (val as ObservationType) : undefined,
            }))
          }}
          disabled={disabled}
        />
        <label style={labelStyle}>Reporter</label>
        <DepartmentDropdown
          defaultValue={formData.department}
          onValueChange={(val) => {
            setFormData((prev) => ({
              ...prev,
              department: val ? (val as Department) : undefined,
            }))
          }}
          disabled={disabled}
        />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Equipment</label>
        <input
          type='text'
          style={inputBaseStyle}
          value={formData.equipment || ''}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              equipment: e.target.value,
            }))
          }
          placeholder='Equipment name'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>

      <div style={rowStyle}>
        <label style={{ ...labelStyle, alignSelf: 'flex-start' }}>
          <span
            style={{ color: '#ff4444', marginRight: '4px', fontSize: '20px' }}>
            *
          </span>
          Notes
        </label>
        <textarea
          style={{
            ...inputBaseStyle,
            minHeight: '80px',
            resize: 'vertical',
          }}
          value={formData.description || ''}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              description: e.target.value,
            }))
          }
          placeholder='Notes...'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>

      <div style={threeColumnGridStyle}>
        <label style={labelStyle}>Area ID</label>
        <input
          type='text'
          style={inputBaseStyle}
          value={formData.area_id?.toString() ?? ''}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, area_id: e.target.value }))
          }
          placeholder='Area ID'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
        <label style={labelStyle}>Component</label>
        <input
          type='text'
          style={inputBaseStyle}
          value={formData.component || ''}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              component: e.target.value,
            }))
          }
          placeholder='Component'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
        <label style={labelStyle}>Fault</label>
        <input
          type='text'
          style={inputBaseStyle}
          value={formData.name || ''}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, name: e.target.value }))
          }
          placeholder='Fault name'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  )
}
